/**
 * Function that maps callStats data into a new object with as many properties as the tabs you want to show
 * each one with counters, donut and legend data to display.
 *
 * @param {Object} massiveStats - Object. Contains the sends massive  stats from BE.
 * @param {Object} intl - Object. Contains internationalization messages.
 * @param {String} title - String. First tab title.
 *
 * @returns {Object} Formatted massive stats for StatsBox component.
 */

export default (massiveStats, intl, theme) => {
  const { totalCount, opened, sent, tagCounters } = massiveStats || {};

  const mappedCounters = (tagCounters || []).map(({ id, name, count }) => {
    const color = theme.custom.stringToColor(intl.messages[name] ?? name);
    return {
      id:
        id === 'NOFEED'
          ? intl.messages.NO_INTERACTIONS
          : intl.messages[name]
            ? intl.messages[name]
            : name,
      value: count,
      color: { light: color, dark: color }, //DonutChart and legend read color[themeMode]
    };
  });

  return {
    text: intl.messages.OUTCOMES, //overrides the donut label (campaign name is too long)
    //shown in SendsSummary instead of StatsBox counters
    summary: {
      total: totalCount || 0,
      sent: sent || 0,
      opened: opened || 0,
      interactions: (tagCounters || [])
        .filter(({ id }) => id !== 'NOFEED')
        .reduce((acc, { count }) => acc + (count || 0), 0),
    },
    donut: mappedCounters,
    legend: {
      data: mappedCounters?.map(({ id, value }) => `${id}: ${value}`),
      colors: mappedCounters?.map(({ color }) => color),
    },
  };
};
